export default class ServicesIndex {
    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {
        this.initSlick();
        this.initHash();
    }

    initHash(){
        if(window.location.hash){
            var hash = window.location.hash;
            var elem = $(hash +"-tab");
            if(elem.length){
                elem.trigger("click");
            }
        }
    }

    initSlick(){
        this.$view.find(".regular").slick({
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        arrows: false,
                        slidesToShow: 1
                    }
                }
            ]

        });
    }
}
//
//
// window.ServicePage = {
//
//     initHash: function(){
//         //test
//         if(window.location.hash){
//             var hash = window.location.hash;
//             var elem = $(hash +"-tab");
//             if(elem.length){
//                 elem.trigger("click");
//             }
//         }
//     },
//     initSlick: function(){
//         $(".regular").slick({
//             dots: true,
//             infinite: true,
//             slidesToShow: 3,
//             slidesToScroll: 3,
//             responsive: [
//                 {
//                     breakpoint: 1024,
//                     settings: {
//                         slidesToShow: 2
//                     }
//                 },
//                 {
//                     breakpoint: 600,
//                     settings: {
//                         arrows: false,
//                         slidesToShow: 1
//                     }
//                 }
//             ]
//
//         });
//     },
//     init: function () {
//         this.initSlick();
//         this.initHash();
//     }
// };
//
// (function ($) {
//     ServicePage.init();
// })(jQuery);